/* Script mm-scroll-grab-instafeed.js */
document.addEventListener("DOMContentLoaded", () => {
  waitForElement();
});

function waitForElement(){
  if(document.querySelector("#insta-feed>div") != null){
      mmScroll()
  }
  else{
      setTimeout(waitForElement, 2000);
  }
}

function mmScroll() {
  var slider = document.querySelector("#insta-feed>div");
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
  });
  slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
  });
  slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
  });
}
